import { atom } from "recoil"

const roomState = atom({
  key: 'room',
  default: {
    isJoin: false,
  }
});

export default roomState;